require('../../modules/es6.number.is-safe-integer');
module.exports = require('../../modules/_core').Number.isSafeInteger;



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/library/fn/number/is-safe-integer.js
// module id = 1980
// module chunks = 0